<template>
  <ElTable
    :data="campaigns"
    show-overflow-tooltip
    stripe
    :row-style="{ cursor: 'pointer' }"
    row-key="id"
    @row-click="goToCampaign"
  >
    <ElTableColumn
      width="200"
      prop="name"
      :label="$t('ADVERTISEMENT.CAMPAIGNS.NAME')"
      fixed
    />
    <ElTableColumn
      width="150"
      prop="packageName"
      :label="$t('ADVERTISEMENT.CAMPAIGNS.PACKAGE_NAME')"
    />
    <ElTableColumn
      width="130"
      :label="$t('ADVERTISEMENT.CAMPAIGNS.BUDGET')"
      prop="remainingBudget"
      sortable
    >
      <template slot-scope="{ row: { remainingBudget } }">
        {{ priceFormat(remainingBudget) }}
      </template>
    </ElTableColumn>

    <ElTableColumn
      width="130"
      :label="$t('ADVERTISEMENT.CAMPAIGNS.SPENT_BUDGET')"
      prop="spentBudget"
      sortable
    >
      <template slot-scope="{ row: { spentBudget } }">
        {{ priceFormat(spentBudget) }}
      </template>
    </ElTableColumn>

    <ElTableColumn
      width="100"
      :label="$t('ADVERTISEMENT.CAMPAIGNS.START_DATE')"
      prop="startDate"
    >
      <template slot-scope="{ row: { startDate } }">
        {{ translateDate(startDate) }}
      </template>
    </ElTableColumn>
    <ElTableColumn
      width="100"
      :label="$t('ADVERTISEMENT.CAMPAIGNS.END_DATE')"
      prop="endDate"
    >
      <template slot-scope="{ row: { endDate } }">
        {{ translateDate(endDate) }}
      </template>
    </ElTableColumn>
    <ColumnWithHelp
      :width="100"
      :title="$t('ADVERTISEMENT.CAMPAIGNS.STATUS')"
      :content="$t('ADVERTISEMENT.CAMPAIGNS.STATUS_DISCOVERY_DESCRIPTION')"
      :label="$t('ADVERTISEMENT.CAMPAIGNS.STATUS')"
    >
      <template slot-scope="{ row: { status } }">
        {{ $t(translateCampaignStatus(status.toLowerCase())) }}
      </template>
    </ColumnWithHelp>
    <ElTableColumn
      width="150"
      sortable
      :label="$t('ADVERTISEMENT.CAMPAIGNS.BASIC.INSTALLS_COUNT')"
      prop="installCount"
    />
    <ElTableColumn
      width="200"
      sortable
      :label="$t('ADVERTISEMENT.CAMPAIGNS.BASIC.AVERAGE_INSTALL_PRICE')"
      prop="averageInstallCost"
    >
      <template slot-scope="{ row: { averageInstallCost } }">
        {{ priceFormat(averageInstallCost) }}
      </template>
    </ElTableColumn>
  </ElTable>
</template>

<script>
import ColumnWithHelp from '@@/advertisement/common/ColumnWithHelp';
import { format as priceFormat } from '@/utils/number';
import { dateFormat } from '@/utils/date';
import lang from '@/mixins/lang';
import translateCampaignStatus from '../../common/utility/translators/translateCampaignStatus';

export default {
  components: {
    ColumnWithHelp,
  },
  mixins: [lang],
  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
    campaigns: {
      type: Array,
      required: true,
    },
  },
  methods: {
    translateCampaignStatus,
    priceFormat,
    translateDate(date) {
      let toFormat = 'DD/MM/YYYY';

      if (this.lang === 'fa') {
        toFormat = 'jYYYY/jMM/jDD';
      }

      return dateFormat()(toFormat)(date);
    },
    goToCampaign({ id: campaignId }) {
      this.$router.push({
        name: 'basic-ads-campaign-info',
        params: { campaignId },
      });
    },
  },
};
</script>
